import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import AuthLayout from "../components/AuthLayout";
import { Alert, Spinner } from "../components/ui";

function ActivateAccount() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }

        const activateAccount = async () => {
            try {
                setLoading(true);
                await axiosInstance.post("/register/activate", { token });
                setMessage("Your account has been successfully activated. Redirecting to login...");
                setErrorMessage("");
                setLoading(false);

                setTimeout(() => {
                    navigate("/login");
                }, 3000);
            } catch (err) {
                setLoading(false);
                if (err.response?.status === 400) {
                    setErrorMessage(err.response.data.message);
                } else {
                    setErrorMessage("There was a problem activating your account.");
                }
            }
        };

        activateAccount();
    }, [token, navigate]);

    return (
        <AuthLayout title="Activating your account">
            {loading && (
                <div className="flex items-center justify-center gap-3 py-6">
                    <Spinner className="h-6 w-6 text-red-500 dark:text-orange-400" />
                    <span className="text-sm font-semibold text-gray-500 dark:text-slate-400">
                        Activating…
                    </span>
                </div>
            )}
            {!loading && message && <Alert tone="success">{message}</Alert>}
            {!loading && errorMessage && <Alert tone="error">{errorMessage}</Alert>}

            <p className="mt-5 text-center text-sm text-gray-500 dark:text-slate-400">
                Back to{" "}
                <a
                    href="/login"
                    className="font-semibold text-red-600 transition hover:text-red-500 dark:text-orange-400"
                >
                    Login
                </a>
            </p>
        </AuthLayout>
    );
}

export default ActivateAccount;